import React from 'react';
import { renderContent, renderContentWithParams } from 'utilities/content/content-utilities';
import { TypographyComponent as TypographyElement } from '@tvg/fuse-design';
import { getEndAndStartDate } from 'utilities/date/date';

interface Props {
  voucherCode: string;
  startDate: string;
  endDate: string;
  offerTerms1: string;
  offerTerms2?: string;
  offerTerms3?: string;
  offerTerms4?: string;
}

function CreditToAccountPage(props: Props) {
  const { voucherCode, startDate, endDate, offerTerms1, offerTerms2, offerTerms3, offerTerms4 } = props;
  const offerRange = getEndAndStartDate(startDate, endDate);
  const offerTerms4Text =
    offerTerms4 || 'Order must be placed online. If you return your item, the credit will be reversed.';

  return (
    <>
      <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-offer-terms-1">
        <strong>{`1. ${offerTerms1}`}</strong>
        <br />
      </TypographyElement>

      {offerTerms2 && (
        <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-offer-terms-2">
          <strong>{`2. ${offerTerms2}`}</strong>
          <br />
        </TypographyElement>
      )}

      {offerTerms3 && (
        <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-offer-terms-3">
          <strong>{`3. ${offerTerms3}`}</strong>
          <br />
        </TypographyElement>
      )}

      <TypographyElement
        dangerouslySetInnerHTML={{
          __html: renderContentWithParams({
            id: 'verypay.CTA.FAQ.order.info',
            params: [offerTerms4Text, voucherCode, offerRange],
          }),
        }}
        type="paragraph"
        size="1"
        tag="p"
        data-testid="cta-dialog-order-info"
      />

      <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-question-1-answer-1">
        <strong>{renderContent('verypay.dialog.bnpl.questions.question1')}</strong>
        <br />
        {renderContent('verypay.dialog.bnpl.questions.answer1.text1')}
      </TypographyElement>

      <TypographyElement
        dangerouslySetInnerHTML={{
          __html: renderContent('verypay.dialog.bnpl.questions.answer1.text2'),
        }}
        type="paragraph"
        size="1"
        tag="p"
        data-testid="cta-dialog-question-1-answer-2"
      />

      <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-question-2-answer-1">
        <strong>{renderContent('verypay.dialog.bnpl.questions.question2')}</strong>
        <br />
        {renderContent('verypay.dialog.bnpl.questions.answer2')}
      </TypographyElement>

      <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-question-3-answer-1">
        <strong>{renderContent('verypay.dialog.bnpl.questions.question3')}</strong>
        <br />
        {renderContent('verypay.dialog.bnpl.questions.answer3.text1')}
      </TypographyElement>

      <TypographyElement
        dangerouslySetInnerHTML={{
          __html: renderContent('verypay.dialog.bnpl.questions.answer3.text2'),
        }}
        type="paragraph"
        size="1"
        tag="p"
        data-testid="cta-dialog-question-3-answer-2"
      />

      <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-question-4-answer-1">
        <strong>{renderContent('verypay.dialog.bnpl.questions.question4')}</strong>
        <br />
        {renderContent('verypay.dialog.bnpl.questions.answer4')}
      </TypographyElement>

      <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-question-5-answer-1">
        <strong>{renderContent('verypay.dialog.bnpl.questions.question5')}</strong>
        <br />
        {renderContent('verypay.dialog.bnpl.questions.answer5.text1')}
      </TypographyElement>

      <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-question-5-answer-2">
        {renderContent('verypay.dialog.bnpl.questions.answer5.text2')}
      </TypographyElement>

      <TypographyElement
        dangerouslySetInnerHTML={{
          __html: renderContent('verypay.dialog.bnpl.questions.answer5.text3'),
        }}
        type="paragraph"
        size="1"
        tag="p"
        data-testid="cta-dialog-question-5-answer-3"
      />

      <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-question-6-answer-1">
        <strong>{renderContent('verypay.dialog.bnpl.questions.question6')}</strong>
        <br />
        {renderContent('verypay.dialog.bnpl.questions.answer6')}
      </TypographyElement>

      <TypographyElement type="paragraph" size="1" tag="p" data-testid="cta-dialog-question-7-answer-1">
        <strong>{renderContent('verypay.dialog.bnpl.questions.question7')}</strong>
        <br />
        {renderContent('verypay.dialog.bnpl.questions.answer7')}
      </TypographyElement>
    </>
  );
}

export default CreditToAccountPage;
